import { PlusOutlined } from '@ant-design/icons';
import { Drawer, Modal, ScrollArea } from '@mantine/core';
import { Col, Row } from 'antd';
import useDevice from 'hooks/useDevice';
import React from 'react';
import { formatTimeString, format_curency } from 'utils';
import ScoreLine from '../ScoreLine';
import { Main } from './style';


const TermAndPoliciesModal = ({ opened, handleOpened, assetData, listRank }) => {

  const { isDesktop, isMobile } = useDevice();
  const { date, month, year } = formatTimeString(assetData.lastRankChangedTime);

  return (
    <Modal
      opened={opened}
      onClose={() => handleOpened(false)}
      size={'60vw'}
      centered
      withCloseButton={false}
      radius={8}
      padding={0}
      classNames={{
        modal: 'min-w-[870px]',
      }}
    >
      <PlusOutlined
        onClick={() => handleOpened(false)}
        className='absolute z-50 right-4 top-4 cursor-pointer'
        style={{
          color: assetData.mainColor,
          fontSize: 24,
        }}
        rotate={45}
      />
      <div
        className='flex flex-wrap justify-center md:justify-start items-center w-full h-250px bg-white md:h-150px py-6 px-2 md:px-6 md:rounded-t-lg'
        style={{
          backgroundImage: `url(${assetData.urlBackground})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        <div className='flex items-center relative'>
          <img src={assetData.bigIcon} alt='' />
          <div className='pl-2'>
            <h3
              className='text-xl'
              style={{
                color: `${assetData.mainColor}`,
              }}
            >
              <span className='capitalize'>{assetData.rankName}</span>
            </h3>
            <p
              className='font-light text-12px'
              style={{
                color: `${assetData.textDate}`,
              }}
            >
              Ngày phân hạng: {date}/{month}/{year}
            </p>
          </div>
          <div className='h-full bg-979797 mx-4' style={{ height: '30px', width: '1px' }}></div>
          <div className='flex items-center'>
            <div>
              <p
                className='text-10px'
                style={{
                  color: `${assetData.textPoint}`,
                }}
              >
                Điểm xếp hạng
              </p>
              <p
                className='text-20px'
                style={{
                  color: `${assetData.mainColor}`,
                  minWidth: '80px',
                  paddingRight: '10px'
                }}
              >
                {format_curency(assetData.point)}
              </p>
            </div>
          </div>
        </div>
        {isDesktop ? (
          <div className='block h-24 bg-EEEEEE mx-5 ml-10' style={{ width: '1px' }}></div>
        ) : (
          ''
        )}
        <div className='w-full lg:w-1/2'>
          <ScoreLine listRank={listRank} assetData={assetData} />
        </div>
      </div>
      <ScrollArea style={{ height: '500px', overflowY: 'auto' }}>
        {isDesktop ? <TablePolicies /> : null}
        {isMobile ? (
          <Drawer
            opened={opened}
            onClose={() => handleOpened(false)}
            size='xl'
            position='right'
            withCloseButton={false}
            padding={0}
            transitionDuration={1000}
            transition='slide-right'
          >
            <ScrollArea style={{ height: '90vh', overflow: 'auto' }}>
              <div className='font-averta-regular'>
                <PlusOutlined
                  onClick={() => handleOpened(false)}
                  className='absolute z-50 left-4 top-8 p-1 mr-4 cursor-pointer'
                  style={{
                    color: '#000',
                    fontSize: 20,
                  }}
                  rotate={45}
                />
                <p className='text-20px ml-16 mt-8'>Xếp hạng</p>
                <div className='flex justify-between text-12px leading-4 py-3 mx-6 mt-3 border-b'>
                  <p className='text-535A66'>Hạng thẻ</p>
                  <p className='text-C4860B'>{assetData.rankName}</p>
                </div>
                <div className='flex justify-between text-12px leading-4 py-3 mx-6 border-b'>
                  <p className='text-535A66'>Điểm xếp hạng</p>
                  <p className='text-C4860B'>{format_curency(assetData.point)}</p>
                </div>
                <div className='flex justify-between text-12px leading-4 py-3 mx-6 border-b'>
                  <p className='text-535A66'>Ngày phân hạng</p>
                  <p>
                    {date}/{month}/{year}
                  </p>
                </div>
              </div>
              <ScoreLine listRank={listRank} assetData={assetData} simpleMode />
              <TablePolicies />
            </ScrollArea>
          </Drawer>
        ) : null}
      </ScrollArea>
    </Modal>
  );
};

const TablePolicies = () => {
  return (
    <Main>
      <Row gutter={[20]} className='row'>
        <Col lg={{ span: 24 }} xl={{ span: 24 }}>
          <div
            className='mb-6 mb-xl-6'
            style={{
              padding: '2rem',
              borderRadius: '14px',
            }}
          >
            <Row gutter={[20]}>
              <div className='col-md-12' style={{ margin: 'auto', textAlign: 'left' }}>
                <div
                  className='col'
                  style={{
                    textAlign: 'left',
                    width: '90%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <u
                      className='h5 mb-0 '
                      style={{
                        fontSize: '25px',
                        fontWeight: 'bold',
                        color: 'rgba(0, 79, 158, 1)',
                      }}
                    >
                      ĐIỀU KHOẢN CHƯƠNG TRÌNH
                    </u>
                  </div>
                  <div style={{ textAlign: 'center', fontWeight: 'bold',color: 'rgb(0 139 211)' }}>
                    <span>(Thời gian áp dụng: 15/7/2022)</span>
                  </div>
                  <br />
                  <div>
                    <span style={{ fontSize: '14px' }}>
                      - BaoViet Loyalty là Chương trình tích điểm đổi quà dành cho các{' '}
                      <b>Khách hàng thân thiết</b> của Bảo Việt Nhân thọ. Thông qua cổng thông tin
                      khách hàng <b>MyBVLife</b>, khách hàng chủ động lựa chọn quà tặng theo sở
                      thích cá nhân.
                    </span>
                  </div>
                  <div>
                    <span style={{ fontSize: '14px' }}>
                      <span style={{ fontWeight: 'bold',color: 'rgb(0 139 211)'}}>Đối tượng áp dụng</span>: Khách hàng là Bên mua bảo hiểm cá nhân có tổng phí quy năm các Hợp đồng còn hiệu lực từ 50 triệu đồng trở lên và không bao gồm phí đóng thêm.
                    </span>
                  </div>
                  <br />
                  <div>
                    <b style={{ fontSize: '14px',fontWeight: 'bold',color: 'rgb(0 139 211)' }}>Phân hạng khách hàng</b>
                    <Row
                      gutter={[20]}
                      className='row'
                      style={{ width: '100%', paddingTop: '10px' }}
                    >
                      <Col sm={{ span: 24 }} xs={{ span: 24 }}>
                        <table responsive className='table cus-table cus-table-x' width='100%'>
                          <thead>
                            <tr>
                              <th className='text-center'>
                                <b>Phân hạng </b>
                              </th>
                              <th className='text-center'>
                                <b>Tổng phí quy năm các Hợp đồng </b>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className='text-center'>Gold</td>
                              <td className='text-center'>
                                Từ 50 triệu đồng đến dưới 150 triệu đồng
                              </td>
                            </tr>
                            <tr>
                              <td className='text-center'>Platinum</td>
                              <td className='text-center'>
                                Từ 150 triệu đồng đến dưới 300 triệu đồng
                              </td>
                            </tr>
                            <tr>
                              <td className='text-center'>Diamond</td>
                              <td className='text-center'>Từ 300 triệu đồng trở lên</td>
                            </tr>
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  </div>
                  <br />
                  <div>
                    <div style={{ fontSize: '14px' }}>
                      - Tổng phí quy năm là tổng phí cam kết trên Hợp đồng tính theo năm của các Hợp
                      đồng bảo hiểm có hiệu lực tại thời điểm xét hạng, không bao gồm khoản phí đóng
                      thêm. đóng phí 1 lần, phí quy năm được tính bằng 10% phí một lần.
                    </div>
                    <div style={{ fontSize: '14px' }}>
                      - Phân hạng khách hàng xét 1 tháng một lần vào ngày 15 hàng tháng. Thời gian
                      hiệu lực phân hạng là 12 tháng.
                    </div>
                  </div>
                  <br />
                  <div style={{ width: '100%' }}>
                    <span style={{ fontSize: '14px' }}>
                      <b style={{ fontWeight: 'bold',color: 'rgb(0 139 211)' }}>Tiêu chí tặng điểm: </b>1 điểm tương đương 1 Việt Nam đồng
                    </span>
                    <Row
                      gutter={[20]}
                      className='row'
                      style={{ width: '100%', paddingTop: '10px' }}
                    >
                      <Col sm={{ span: 24 }} xs={{ span: 24 }}>
                        <table responsive className='table cus-table cus-table-x'>
                          <thead>
                            <tr>
                              <th
                                className='text-center'
                                row='0'
                                rowSpan='2'
                                style={{ width: '20%' }}
                              >
                                <b>Tiêu chí tặng điểm</b>
                              </th>
                              <th className='text-center' row='0' colSpan='3'>
                                <b>Số điểm tặng khách hàng </b>
                              </th>
                              <th
                                className='text-center'
                                row='0'
                                rowSpan='2'
                                style={{ width: '40%' }}
                              >
                                <b>Chi tiết </b>
                              </th>
                            </tr>
                            <tr>
                              <th className='text-center' row='1'>
                                <b>Gold</b>
                              </th>
                              <th className='text-center' row='1'>
                                <b>Platinum</b>
                              </th>
                              <th className='text-center' row='1'>
                                <b>Diamond</b>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Sinh nhật</td>
                              <td className='text-center'>300.000</td>
                              <td className='text-center'>600.000</td>
                              <td className='text-center'>900.000</td>
                              <td>Tặng điểm vào ngày sinh nhật BMBH</td>
                            </tr>
                            <tr>
                              <td>Đóng phí bảo hiểm định kỳ </td>
                              <td className='text-center' colSpan='3'>
                                1.000 VND phí thực đóng = 2 điểm
                              </td>
                              <td>
                                Tặng khi KH đóng phí (không bao gồm các giao dịch miễn đóng phí, vay
                                phí tự động). Với phí đầu tiên, điểm thưởng được tặng vào tài khoản
                                MyBVLife sau 31 ngày kể từ ngày phát hành Hợp đồng.
                              </td>
                            </tr>
                            <tr>
                              <td>Đăng nhập lần đầu vào MyBVLife </td>
                              <td className='text-center' colSpan='3'>
                                100.000
                              </td>
                              <td>
                                Chỉ dành cho KH đủ điều kiện là thành viên mới BaoViet Loyalty từ
                                15/7/2022. Mỗi KH chỉ được tặng điểm 1 lần khi đăng nhập MyBVLife.
                              </td>
                            </tr>
                            <tr>
                              <td>Đủ email & số điện thoại</td>
                              <td className='text-center' colSpan='3'>
                                5.000
                              </td>
                              <td>Chỉ áp dụng 1 lần khi khách hàng đã đủ thông tin liên hệ</td>
                            </tr>

                            <tr>
                              <td>Kỷ niệm Hợp đồng</td>
                              <td className='text-center'>10.000</td>
                              <td className='text-center'>15.000</td>
                              <td className='text-center'>20.000</td>
                              <td>Tặng điểm khách hàng vào ngày kỷ niệm Hợp đồng </td>
                            </tr>
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  </div>
                  <br />
                  <div>
                    <div style={{ fontSize: '14px' }}>
                      - Điểm thưởng tích lũy của KH phát sinh trong năm sẽ hết hạn vào 31/12 năm
                      liền kề.
                    </div>
                  </div>
                  <br />
                  <div style={{ textAlign: 'center' }}>
                    <img
                      style={{ marginLeft: 'auto', marginRight: 'auto', borderRadius: '15px' }}
                      src={'/assets/images/loyalty/pc/imageDetail.PNG'}
                      width={'600px'}
                    ></img>
                  </div>
                  <br />
                  <div>
                    <div style={{ fontSize: '14px' }}>
                      <i>
                        Ví dụ: Năm 2024 số điểm tích lũy chưa sử dụng của khách hàng là 500.000
                        điểm, số điểm này sẽ hết hạn vào ngày <b>31/12/2025</b>. Sau thời gian này,
                        nếu khách hàng không sử dụng điểm thưởng của năm 2024, điểm sẽ không còn giá
                        trị sử dụng.
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
          </div>
        </Col>
      </Row>
    </Main>
  );
};

export default TermAndPoliciesModal;
